import firebase from "firebase";
import "regenerator-runtime/runtime";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATA_BASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const fire = firebase.initializeApp(firebaseConfig);

(() => {
  const remoteConfig = fire.remoteConfig();
  remoteConfig.defaultConfig = {
    marketHolidays: [
      "26-Jan-2021",
      "11-Mar-2021",
      "29-Mar-2021",
      "02-Apr-2021",
      "14-Apr-2021",
      "21-Apr-2021",
      "13-May-2021",
      "21-Jul-2021",
      "19-Aug-2021",
      "10-Sep-2021",
      "15-Oct-2021",
      "05-Nov-2021",
      "19-Nov-2021",
    ],
  };
  try {
    remoteConfig.fetchAndActivate();
    let advisorDashboardConfig = remoteConfig.getValue(
      "advisorDashboardConfig"
    );
    let advisorDashboardConfigJSON = JSON.parse(
      advisorDashboardConfig.asString()
    );
    window.marketHolidayList =
      "marketHolidays" in advisorDashboardConfigJSON
        ? advisorDashboardConfigJSON.marketHolidays
        : remoteConfig.defaultConfig.marketHolidays;
  } catch (error) {
    console.log(error);
    window.marketHolidayList = remoteConfig.defaultConfig.marketHolidays;
  }
})();

export default fire;
